import $ from "jquery";

$(function() {
	$(document).on('click', 'div.spoiler-title', function() {
		$(this)
			.children()
			.first()
			.toggleClass('show-icon')
			.toggleClass('hide-icon');
		$(this)
			.parent().children().last().toggle();
	});
});
